<template>

	<div class="row">
		<div class="col-md-6 col-md-offset-3 col-sm-12">
			<h3 class="page-header">404: Resource Not Found</h3>
            <div class="card mb-4">
                <div class="card-body">
                    Resource Not Found
                    <button class="btn btn-sm btn-primary" v-on:click="routerBack()">
                        <i class="fa fa-caret-left"></i> Back to Last Page
                    </button>
                </div>
            </div>
            <one-click-login></one-click-login>
    	</div>
    </div>
</template>

<script>
    export default {
    	data: function() {
            return {}
        },

        methods: {
            routerBack(){
                this.$router.go(-2);
            }
        },

        mounted() {

        }
    }
</script>
